import { Component } from "@angular/core";

@Component({
  selector: "admin-layout-standard",
  templateUrl: "./standard.component.html",
  styleUrls: ["./standard.component.css"]
})
export class AdminLayoutStandardComponent {

}
